export var AuthActionType;
(function (AuthActionType) {
    AuthActionType["Clear"] = "clearAuth";
    AuthActionType["Update"] = "updateAuth";
})(AuthActionType || (AuthActionType = {}));
export function clearAuth() {
    return { type: AuthActionType.Clear };
}
export function updateAuth(token) {
    return {
        data: token,
        type: AuthActionType.Update
    };
}
